import { render, staticRenderFns } from "./MemberType.vue?vue&type=template&id=3f5fef8e&scoped=true&"
import script from "./MemberType.vue?vue&type=script&lang=js&"
export * from "./MemberType.vue?vue&type=script&lang=js&"
import style0 from "./MemberType.vue?vue&type=style&index=0&id=3f5fef8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5fef8e",
  null
  
)

export default component.exports